import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown, faAngleRight } from '@rq-ratings/pro-regular-svg-icons'
import classNames from 'classnames'
import React, { useState } from 'react'

import { useIsMinWidthSm } from '../../hooks/useIsMinWidthSm'

interface CollapsibleProps extends React.HTMLAttributes<HTMLDivElement> {
  header:
    | React.ReactNode
    | ((renderProps: { isOpen: boolean }) => React.ReactNode)
  children: React.ReactNode
  isCollapsibleEnabled?: boolean
  hideHeaderWhenCollapsibleDisabled?: boolean
}

const Collapsible: React.FC<CollapsibleProps> = ({
  header,
  children,
  className,
  isCollapsibleEnabled,
  hideHeaderWhenCollapsibleDisabled,
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const isSmWidth = !useIsMinWidthSm()

  if (isCollapsibleEnabled === undefined) {
    // If isCollapsibleEnabled is not explicitly set then only enable for small devices
    isCollapsibleEnabled = isSmWidth
  }

  const hideHeader = hideHeaderWhenCollapsibleDisabled && !isCollapsibleEnabled

  const toggleCollapsible = () => {
    setIsOpen(!isOpen)
  }

  const shouldShowContent = isOpen || !isCollapsibleEnabled

  return (
    <div className={classNames('collapsible', className)}>
      {!hideHeader && (
        <div
          className="collapsible-header cursor-pointer"
          onClick={toggleCollapsible}
        >
          <div className={isCollapsibleEnabled ? 'd-inline-block' : 'w-100'}>
            {typeof header === 'function'
              ? header({ isOpen: shouldShowContent })
              : header}
          </div>

          {isCollapsibleEnabled && (
            <span className="collapsible-icon cursor-pointer ms-2">
              {isOpen ? (
                <FontAwesomeIcon icon={faAngleDown} />
              ) : (
                <FontAwesomeIcon icon={faAngleRight} />
              )}
            </span>
          )}
        </div>
      )}

      {shouldShowContent && (
        <div className="collapsible-content">{children}</div>
      )}
    </div>
  )
}

export default Collapsible
